const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/team/field-activity.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/team/field-activity.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SupervisorActivityPendingState } from '@/features/supervisor/components/SupervisorActivityPendingState';
import { SupervisorActivityRail } from '@/features/supervisor/components/SupervisorActivityRail';
import { supervisorActivitySearchSchema } from '@/features/supervisor/lib/search';
import { toSupervisorActivitySessionFilters, toSupervisorTeamScope } from '@/features/supervisor/lib/teamSearch';
import { supervisorSessionsQuery, supervisorSummaryQuery } from '@/features/supervisor/services/supervisorQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/supervisor/team/field-activity')({
  validateSearch: supervisorActivitySearchSchema,
  loaderDeps: ({
    search
  }) => ({
    scope: toSupervisorTeamScope(search),
    sessionFilters: toSupervisorActivitySessionFilters(search)
  }),
  loader: ({
    context,
    deps
  }) => Promise.all([context.queryClient.ensureQueryData(supervisorSummaryQuery(deps.scope)), context.queryClient.ensureInfiniteQueryData(supervisorSessionsQuery(deps.sessionFilters))]),
  staticData: {
    sectionShell: {
      secondarySidebar: SupervisorActivityRail
    }
  },
  pendingComponent: SupervisorActivityPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});